/* IC 2026 Option E behaviour: recently viewed rail, basket page quantities, lamp switch, search sort. */
(function () {
  'use strict';
  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var KEY = 'ic_recently_viewed';
  var fmt = new Intl.NumberFormat('en-GB', { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP' });
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function readList() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function writeList(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} }

  /* ---------- Recently viewed ---------- */
  function priceHtml(p) {
    var pounds = Math.floor(p.price / 100), pence = ('0' + (p.price % 100)).slice(-2);
    var sale = p.compare_at_price && p.compare_at_price > p.price;
    var h = '<div class="ic-price' + (sale ? ' ic-price--sale' : '') + '"><span class="ic-price__now"><span class="ic-sr">' + fmt.format(p.price / 100) + '</span><span aria-hidden="true"><span class="ic-money__sym">£</span>' + pounds + '<sup>' + pence + '</sup></span></span>';
    if (sale) h += '<span class="ic-price__was">' + fmt.format(p.compare_at_price / 100) + '</span>';
    return h + '</div>';
  }
  function card(p, threshold) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
    var v = p.variants && p.variants[0];
    var single = p.variants && p.variants.length === 1;
    var action = !p.available
      ? '<a class="ic-btn ic-card__notify" href="' + p.url + '">Notify me when back</a>'
      : (single ? '<form method="post" action="' + root + 'cart/add" data-ic-add><input type="hidden" name="id" value="' + v.id + '"><input type="hidden" name="quantity" value="1"><button type="submit" class="ic-btn ic-card__add">Add to basket</button></form>'
               : '<a class="ic-btn ic-card__add" href="' + p.url + '">Choose options</a>');
    var deliv = p.available
      ? '<strong>In stock.</strong> ' + (p.price >= threshold * 100 ? 'Free UK delivery' : 'Free UK delivery over £' + threshold)
      : '<strong>Sold out.</strong> Get a restock alert';
    return '<li><div class="ic-card' + (p.available ? '' : ' ic-card--soldout') + '">' +
      '<a class="ic-card__media" href="' + p.url + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="400" height="400">' : '') + '</a>' +
      '<div class="ic-card__body"><h3 class="ic-card__title"><a href="' + p.url + '">' + esc(p.title) + '</a></h3>' + priceHtml(p) +
      '<p class="ic-card__delivery' + (p.available ? '' : ' ic-card__delivery--out') + '">' + deliv + '</p>' +
      '<div class="ic-card__action">' + action + '</div></div></div></li>';
  }
  function initRecent() {
    var current = (document.body.getAttribute('data-ic-product') || '');
    var sec = qsa('[data-ic-recent]');
    sec.forEach(function (s) { if (s.dataset.current) current = s.dataset.current; });
    var list = readList();
    if (current) { list = list.filter(function (h) { return h !== current; }); list.unshift(current); writeList(list.slice(0, 20)); }
    if (!sec.length) return;
    sec.forEach(function (s) {
      var limit = Number(s.dataset.limit || 6);
      var threshold = Number(s.dataset.threshold || 25);
      var show = list.filter(function (h) { return h !== current; }).slice(0, limit);
      if (!show.length) return;
      Promise.all(show.map(function (h) {
        return fetch(root + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (items) {
        items = items.filter(Boolean);
        if (!items.length) return;
        qs('[data-ic-recent-list]', s).innerHTML = items.map(function (p) { return card(p, threshold); }).join('');
        s.hidden = false;
      });
      var clear = qs('[data-ic-recent-clear]', s);
      if (clear) clear.addEventListener('click', function () { writeList([]); s.hidden = true; });
    });
  }

  /* ---------- Basket page ---------- */
  function initCart() {
    var page = qs('[data-ic-cart]');
    if (!page) return;
    function change(key, qty, line) {
      page.classList.add('is-busy');
      return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .catch(function () { throw new Error('We could not reach the shop. Check your connection and try again.'); }).then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error((typeof j.description === 'string' && j.description) || 'Could not update your basket. Please try again.'); return j; }); })
        .then(function () { return fetch(window.location.pathname + '?section_id=' + page.dataset.section).then(function (r) { return r.text(); }); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = qs('[data-ic-cart]', doc);
          if (fresh) page.replaceWith(fresh);
          initCart();
          var c = fresh && Number(fresh.dataset.count);
          qsa('[data-ic-cart-count]').forEach(function (el) { el.textContent = c; el.hidden = !c; });
        })
        .catch(function (err) {
          page.classList.remove('is-busy');
          var e = line && qs('[data-ic-line-error]', line);
          if (e) { e.textContent = err.message; e.hidden = false; }
        });
    }
    page.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ic-qty]');
      var rm = e.target.closest('[data-ic-remove]');
      var line = e.target.closest('[data-ic-line]');
      if (b && line) {
        var inp = qs('input[name="quantity"]', line);
        var q = Math.max(0, (Number(inp.value) || 1) + Number(b.dataset.icQty));
        change(line.dataset.icLine, q, line);
      } else if (rm && line) {
        change(line.dataset.icLine, 0, line);
      }
    });
    var cf = document.getElementById('IcCartForm');
    if (cf && !cf.dataset.icGuard) {
      cf.dataset.icGuard = '1';
      cf.addEventListener('submit', function (e) {
        var pg = qs('[data-ic-cart]');
        if (!pg || !pg.classList.contains('is-busy')) return;
        e.preventDefault();
        var tries = 0;
        (function wait() {
          var cur = qs('[data-ic-cart]');
          if (cur && cur.classList.contains('is-busy') && tries++ < 40) return setTimeout(wait, 150);
          window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'checkout';
        })();
      });
    }
    page.addEventListener('change', function (e) {
      var inp = e.target.closest('input[name="quantity"]');
      var line = e.target.closest('[data-ic-line]');
      if (inp && line) {
        var nq = Math.floor(Number(inp.value));
        if (inp.value === '' || !(nq >= 1)) { inp.value = inp.defaultValue || 1; return; }
        change(line.dataset.icLine, nq, line);
      }
    });
  }

  /* ---------- Lamp switch: tap to toggle, otherwise the CSS loop runs ---------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.ic-switch');
    if (!sw) return;
    var lamp = sw.closest('.ic-lamp');
    if (!lamp) return;
    e.preventDefault();
    lamp.classList.add('is-manual');
    lamp.classList.toggle('is-lit');
  });

  /* ---------- Search sort ---------- */
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-ic-sort]');
    if (!s) return;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', s.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  /* ---------- Collection page: grid view, Show more pager, price slider, filter groups ---------- */
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  function applyCols() {
    var grid = document.getElementById('product-grid');
    if (!grid || !grid.classList.contains('ic-grid')) return;
    var d = lsGet('ic_cols') || grid.dataset.defaultCols || '4';
    var m = lsGet('ic_mcols') || grid.dataset.defaultMcols || '2';
    grid.setAttribute('data-cols', d);
    grid.setAttribute('data-mcols', m);
    document.querySelectorAll('[data-ic-cols]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.icCols === d)); });
    document.querySelectorAll('[data-ic-mcols]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.icMcols === m)); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ic-cols],[data-ic-mcols]');
    if (!b) return;
    if (b.dataset.icCols) lsSet('ic_cols', b.dataset.icCols); else lsSet('ic_mcols', b.dataset.icMcols);
    applyCols();
  });

  document.addEventListener('click', function (e) {
    var more = e.target.closest && e.target.closest('[data-ic-pager-more]');
    if (!more) return;
    var grid = document.getElementById('product-grid');
    if (!grid || grid.hasAttribute('data-ic-stream')) return;
    e.preventDefault();
    if (more.dataset.busy) return;
    more.dataset.busy = '1'; var label = more.textContent; more.textContent = 'Loading…';
    var u = new URL(more.href, location.origin);
    u.searchParams.set('section_id', grid.dataset.id);
    fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var seen = {};
      grid.querySelectorAll('.ic-card a[href*="/products/"]').forEach(function (a) { seen[a.getAttribute('href').split('?')[0]] = 1; });
      doc.querySelectorAll('#product-grid > li.grid__item:not(.ic-promo-cell):not(.ic-vtile-cell)').forEach(function (li) {
        var a = li.querySelector('.ic-card a[href*="/products/"]'); var h = a ? a.getAttribute('href').split('?')[0] : '';
        if (h && seen[h]) return; seen[h] = 1;
        grid.appendChild(document.importNode(li, true));
      });
      var pager = more.closest('[data-ic-pager]');
      var np = doc.querySelector('[data-ic-pager]');
      if (pager && np) {
        var shownEl = pager.querySelector('[data-ic-pager-shown]'); var ns = np.querySelector('[data-ic-pager-shown]');
        if (shownEl && ns) shownEl.textContent = ns.textContent;
        var bar = pager.querySelector('.ic-coll-more__bar span'), nb = np.querySelector('.ic-coll-more__bar span');
        if (bar && nb) bar.style.width = nb.style.width;
        var nm = np.querySelector('[data-ic-pager-more]');
        if (nm) { more.href = nm.getAttribute('href'); delete more.dataset.busy; more.textContent = label; }
        else more.remove();
        var links = pager.querySelector('.ic-pager__links'), nl = np.querySelector('.ic-pager__links');
        if (links && nl) links.innerHTML = nl.innerHTML;
      }
    }).catch(function () { window.location.href = more.href; });
  });

  function initPriceSliders() {
    document.querySelectorAll('price-range').forEach(function (pr) {
      if (pr.dataset.icSlider) return;
      var lo = pr.querySelector('input[name="filter.v.price.gte"]'), hi = pr.querySelector('input[name="filter.v.price.lte"]');
      if (!lo || !hi) return;
      var num = function (x) { return parseFloat(String(x || '').replace(/[^0-9.]/g, '')); };
      var max = Math.ceil(num(hi.dataset.max || hi.getAttribute('data-max') || hi.placeholder || '100')) || 100;
      pr.dataset.icSlider = '1';
      var wrap = document.createElement('div');
      wrap.className = 'ic-range';
      wrap.innerHTML = '<div class="ic-range__track"><span class="ic-range__fill"></span></div>' +
        '<input type="range" class="ic-range__in" min="0" max="' + max + '" step="1" aria-label="Minimum price">' +
        '<input type="range" class="ic-range__in" min="0" max="' + max + '" step="1" aria-label="Maximum price">' +
        '<div class="ic-range__vals"><span></span><span></span></div>';
      pr.parentNode.insertBefore(wrap, pr);
      var r = wrap.querySelectorAll('input'), fill = wrap.querySelector('.ic-range__fill'), vals = wrap.querySelectorAll('.ic-range__vals span');
      r[0].value = num(lo.value) || 0; r[1].value = num(hi.value) || max;
      function paint() {
        var a = Math.min(+r[0].value, +r[1].value), b = Math.max(+r[0].value, +r[1].value);
        fill.style.left = (a / max * 100) + '%'; fill.style.right = (100 - b / max * 100) + '%';
        vals[0].textContent = '£' + a; vals[1].textContent = '£' + b + (b >= max ? '+' : '');
      }
      var t;
      function push() {
        var a = Math.min(+r[0].value, +r[1].value), b = Math.max(+r[0].value, +r[1].value);
        lo.value = a > 0 ? a : ''; hi.value = b < max ? b : '';
        clearTimeout(t); t = setTimeout(function () { hi.dispatchEvent(new Event('input', { bubbles: true })); }, 350);
      }
      r.forEach(function (x) { x.addEventListener('input', function (ev) { ev.stopPropagation(); paint(); }); x.addEventListener('change', function (ev) { ev.stopPropagation(); push(); }); });
      paint();
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ic-tagmore]');
    if (!b) return;
    var list = b.parentNode.querySelector('.ic-taglist');
    if (!list) return;
    var collapsed = list.classList.toggle('is-collapsed');
    b.textContent = collapsed ? b.dataset.labelMore : b.dataset.labelLess;
  });

  /* Notify Me! app paints its buttons purple with inline !important styles: strip them once so the theme styles apply */
  function tameApps() {
    document.querySelectorAll('.nm-wishlist-button, .restock-alerts-notify-button, .nm-wishlist-open-list-button').forEach(function (b) {
      if (b.dataset.icTamed !== undefined) return;
      b.dataset.icTamed = '1'; b.removeAttribute('style');
    });
    /* Shopify Forms teaser lives in a shadow root: lift it above the bottom nav on phones */
    if (window.matchMedia('(max-width: 749px)').matches) {
      document.querySelectorAll('shopify-forms-embed').forEach(function (h) {
        var sr = h.shadowRoot; if (!sr || sr.querySelector('style[data-ic]')) return;
        var st = document.createElement('style'); st.setAttribute('data-ic', '');
        st.textContent = '*{} [style*="position: fixed"], .teaser, [class*="easer"], [class*="loating"] { bottom: calc(76px + env(safe-area-inset-bottom)) !important; } [class*="appEmbed"] { width: auto !important; max-width: 240px !important; } [class*="teaserContainer"] { padding: 8px 12px !important; min-height: 0 !important; } [class*="teaserHeading"] { font-size: 14px !important; line-height: 1.25 !important; white-space: nowrap !important; margin: 0 !important; }';
        sr.appendChild(st);
      });
    }
  }
  function initVtiles() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var save = navigator.connection && navigator.connection.saveData;
    document.querySelectorAll('.ic-vtile video, .ic-lamp video').forEach(function (vd) {
      if (vd.dataset.icInit) return; vd.dataset.icInit = '1';
      vd.removeAttribute('autoplay'); try { vd.pause(); } catch (e) {}
      if (reduce || save || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { var pr = vd.play(); if (pr && pr.catch) pr.catch(function () {}); } else vd.pause(); }); }, { threshold: 0.4 }).observe(vd);
    });
  }
  function safe(fn) { try { fn(); } catch (e) { if (window.console) console.warn('[ic26]', e); } }
  /* ---------- Estimated delivery date on product pages ----------
     Dispatch days come from the stock line (upper figure of "2 to 3 working days"; same-day = 0 before 2pm UK, else 1),
     plus 2 working days for standard tracked delivery. Weekends and UK bank holidays are skipped. */
  var IC_HOLS = ['2026-12-25','2026-12-28','2027-01-01','2027-03-26','2027-03-29','2027-05-03','2027-05-31','2027-08-30','2027-12-27','2027-12-28'];
  function ukNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false }).formatToParts(new Date());
      var o = {}; parts.forEach(function (p) { o[p.type] = p.value; });
      return { d: new Date(Date.UTC(+o.year, +o.month - 1, +o.day)), h: +o.hour };
    } catch (e) { var n = new Date(); return { d: new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())), h: n.getHours() }; }
  }
  function isWork(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && IC_HOLS.indexOf(d.toISOString().slice(0, 10)) === -1; }
  function addWork(d, n) { var x = new Date(d.getTime()); while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (isWork(x)) n--; } return x; }
  function dispatchDays(t, h, today) {
    t = (t || '').toLowerCase();
    if (/same[ -]day/.test(t)) return (isWork(today) && h < 14) ? 0 : 1;
    if (/next[ -]day/.test(t)) return 1;
    var nums = (t.match(/\d+/g) || []).map(Number).filter(function (n) { return n > 0 && n < 30; });
    return nums.length ? Math.max.apply(null, nums) : 3;
  }
  function initEta() {
    document.querySelectorAll('[data-ic-eta]').forEach(function (el) {
      if (el.dataset.icDone) return; el.dataset.icDone = '1';
      var now = ukNow(), start = now.d;
      var dd = dispatchDays(el.dataset.dispatch, now.h, start);
      var shipDay = dd === 0 ? start : addWork(start, dd);
      if (dd === 0 && !isWork(start)) shipDay = addWork(start, 1);
      var arrive = addWork(shipDay, 2);
      var txt = arrive.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
      el.innerHTML = 'Estimated delivery <strong>' + txt + '</strong>*<span class="ic-delivery__eta-note">*With standard tracked delivery. Depends on the delivery option you choose at checkout.</span>';
    });
  }
  /* ---------- Header nav: arrows when the department list scrolls ---------- */
  /* Small < > arrows on anything that scrolls sideways, so shoppers know there is more.
     Bar-style lists (nav, chips) get edge fades; product rows get round buttons centred on the row. */
  var IC_BAR = '.ic-nav__list, .ic-chips__inner, .ic-shortcuts';
  var IC_ROW = '.ic-hub__links, .ic-types__list, .ic-crests__tabs, .ic-rail, .ic-reels, .ic-shelf, .ic-band__items, .ic-pdp .ic-deal__list, .ic-related-products .ic-rail';
  function initNavArrows() {
    document.querySelectorAll(IC_BAR + ', ' + IC_ROW).forEach(function (list) {
      if (list.dataset.icArrows) return; list.dataset.icArrows = '1';
      var isRow = list.matches(IC_ROW);
      var wrap = list.parentNode; wrap.classList.add('ic-nav__scroller'); if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
      var mk = function (dir) {
        var b = document.createElement('button'); b.type = 'button';
        b.className = 'ic-nav__arrow ic-nav__arrow--' + dir + (isRow ? ' ic-nav__arrow--row' : '');
        b.setAttribute('aria-label', dir === 'prev' ? 'Scroll left' : 'Scroll right');
        b.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="' + (dir === 'prev' ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6') + '"/></svg>';
        b.addEventListener('click', function () { list.scrollBy({ left: (dir === 'prev' ? -1 : 1) * Math.max(200, list.clientWidth * 0.8), behavior: 'smooth' }); });
        if (list.nextSibling) wrap.insertBefore(b, list.nextSibling); else wrap.appendChild(b);
        return b;
      };
      var prev = mk('prev'), next = mk('next');
      function upd() {
        var max = list.scrollWidth - list.clientWidth - 2;
        prev.hidden = list.scrollLeft <= 2; next.hidden = list.scrollLeft >= max || max <= 0;
        if (isRow) {
          var t = list.offsetTop + Math.min(list.offsetHeight / 2, 140) - 18;
          prev.style.top = next.style.top = t + 'px';
          prev.style.left = (list.offsetLeft + 4) + 'px';
          next.style.left = (list.offsetLeft + list.clientWidth - 40) + 'px';
        }
      }
      var raf; function q() { cancelAnimationFrame(raf); raf = requestAnimationFrame(upd); }
      list.addEventListener('scroll', q, { passive: true }); window.addEventListener('resize', q); upd(); setTimeout(upd, 600); setTimeout(upd, 2500);
    });
  }
  function initCollection() { safe(applyCols); safe(initPriceSliders); safe(initVtiles); safe(tameApps); safe(initEta); safe(initNavArrows); }
  /* Touch screens with the desktop nav (tablets): first tap opens the mega menu, second tap follows the link */
  document.addEventListener('click', function (e) {
    if (!window.matchMedia('(hover: none)').matches) return;
    var a = e.target.closest && e.target.closest('.ic-nav__item[data-has-mega] > a');
    if (!a) return;
    var item = a.parentNode;
    if (item.classList.contains('is-open')) return;
    e.preventDefault();
    document.querySelectorAll('.ic-nav__item.is-open').forEach(function (i) { i.classList.remove('is-open'); });
    item.classList.add('is-open');
  }, true);
  var collMo = new MutationObserver(function () { clearTimeout(collMo._t); collMo._t = setTimeout(initCollection, 60); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initRecent(); initCart(); initCollection(); collMo.observe(document.body, { childList: true, subtree: true }); });
  else { initRecent(); initCart(); initCollection(); collMo.observe(document.body, { childList: true, subtree: true }); }
})();
